import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Mail, Phone } from "lucide-react";

const LOGO_URL = "/logo.png";

export default function Footer() {
  return (
    <footer className="bg-[#0A192F] text-[#F9F6F0] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="inline-block bg-[#F9F6F0] rounded-xl px-4 py-3 mb-4">
            <img src={LOGO_URL} alt="Roop Anand" className="h-10 w-auto" />
          </div>
          <p className="text-sm text-[#F9F6F0]/70 leading-relaxed">
            Ayurvedic personal care crafted with tradition, honesty and love. Roop Anand™ — for your natural glow.
          </p>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-[#E65A28] font-inter font-semibold">Shop</h4>
          <ul className="space-y-2 text-sm text-[#F9F6F0]/80">
            <li><Link to="/shop" className="hover:text-[#E65A28]">All Products</Link></li>
            <li><Link to="/category/hair-care" className="hover:text-[#E65A28]">Hair Care</Link></li>
            <li><Link to="/category/skin-care" className="hover:text-[#E65A28]">Skin Care</Link></li>
            <li><Link to="/category/personal-hygiene" className="hover:text-[#E65A28]">Personal Hygiene</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-[#E65A28] font-inter font-semibold">Support</h4>
          <ul className="space-y-2 text-sm text-[#F9F6F0]/80">
            <li><Link to="/account" className="hover:text-[#E65A28]">My Account</Link></li>
            <li><Link to="/account?tab=orders" className="hover:text-[#E65A28]">Track Order</Link></li>
            <li><a href="#" className="hover:text-[#E65A28]">Shipping &amp; Returns</a></li>
            <li><a href="#" className="hover:text-[#E65A28]">Contact Us</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest mb-4 text-[#E65A28] font-inter font-semibold">Get in touch</h4>
          <p className="text-sm flex items-center gap-2 mb-2"><Mail className="h-4 w-4" /> care@roopanand.in</p>
          <p className="text-sm flex items-center gap-2 mb-4"><Phone className="h-4 w-4" /> +91 98XXX XXXXX</p>
          <div className="flex gap-3">
            <a href="#" className="p-2 border border-white/20 rounded-full hover:bg-[#E65A28] hover:border-[#E65A28] transition-colors" aria-label="Instagram"><Instagram className="h-4 w-4" /></a>
            <a href="#" className="p-2 border border-white/20 rounded-full hover:bg-[#E65A28] hover:border-[#E65A28] transition-colors" aria-label="Facebook"><Facebook className="h-4 w-4" /></a>
            <a href="#" className="p-2 border border-white/20 rounded-full hover:bg-[#E65A28] hover:border-[#E65A28] transition-colors" aria-label="Youtube"><Youtube className="h-4 w-4" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-[#F9F6F0]/60">
        © {new Date().getFullYear()} Roop Anand™. All rights reserved. Payments powered by PhonePe Business. Shipping via Delhivery.
      </div>
    </footer>
  );
}
